export const STARRED = 'STARRED';
export const CHECKBOXES = 'CHECKBOXES';
export const HIERARCHY = 'HIERARCHY';
export const TRASH = 'TRASH';
export const SEARCH_MESSAGES = 'SEARCH_MESSAGES';
export const HISTORY = 'HISTORY';
export const CHAT = 'CHAT';
export const X_BOOKMARKS = 'X_BOOKMARKS';
export const REMINDERS = 'REMINDERS';
export const SHARED_WITH_ME = 'SHARED_WITH_ME';
export const DAILY_REVIEW = 'DAILY_REVIEW';
export const WRAPPED = 'WRAPPED';
export const LIBRARY = 'LIBRARY';
